import * as stylex from '@stylexjs/stylex';
import { styles } from '../../styles';
import blocked from '../../assets/blocked.webp';

export const ExpiredInvite = () => {
  return (
    <>
      <div {...stylex.props(styles.content)}>
        <img src={blocked} alt="Приглашение отклонено" {...stylex.props(styles.statusIllustration)} />
        <div {...stylex.props(styles.titleContent)}>
          <p {...stylex.props(styles.titleInfo)}>Срок действия приглашения истек</p>
        </div>
        <p {...stylex.props(styles.subTitleInfo)}>
          К сожалению, время принятия приглашения истекло. До встречи в следующий раз
        </p>
      </div>
      <footer {...stylex.props(styles.infoText)}>
        <p>Связаться с организатором </p>
        <p {...stylex.props(styles.infoLink)}>event@sminex.com</p>
      </footer>
    </>
  );
};
